module.exports = __webpack_public_path__ + "static/media/exercises-step12.1b64ae16.png";